import type { CustomIconProps } from '../CustomIcon';

export const VaultSmallIcon = ({
  color,
  size = 16,
  solid,
  secondaryColor,
  ternaryColor,
  ...props
}: CustomIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <g clipPath='url(#clip0_2346_15755)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.1236 1.33398H4.87568C2.69838 1.33398 1.33334 2.87561 1.33334 5.05723V10.9441C1.33334 13.1257 2.69117 14.6673 4.87568 14.6673H11.1229C13.3074 14.6673 14.6667 13.1257 14.6667 10.9441V5.05723C14.6667 2.87561 13.3074 1.33398 11.1236 1.33398Z'
          stroke={color}
          strokeWidth='1.5'
        />
        <ellipse cx='6.66666' cy='8' rx='2' ry='2' stroke={color} strokeWidth='1.5' />
        <ellipse cx='11.3333' cy='5.33268' rx='0.666667' ry='0.666667' fill={color} />
        <circle cx='11.3333' cy='10.6667' r='0.666667' fill={color} />
        <ellipse cx='11.3333' cy='8.00065' rx='0.666667' ry='0.666667' fill={color} />
      </g>
      <defs>
        <clipPath id='clip0_2346_15755'>
          <rect width={size} height={size} fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
